import useCheckoutContext from '../../../common/hooks/useCheckoutContext';
import { GetDeal_deal } from '../../../common/graphql/queries/__generated__/GetDeal';
import dealStorageService from '../../../../../../common/service/dealStorageService';
import useWidgetContext from '../../../../common/react/useWidgetContext';
import { useCallback, useEffect } from 'react';
import { Routes } from '../../../../common/enum/Routes';
import collectedFilters from '../../../../common/service/collectedFilters';
import { useHistory } from 'react-router';

const useDealData = () => {
  const history = useHistory();
  const {
    configuration: { dimensions },
  } = useWidgetContext();
  const {
    filters: { token },
  } = collectedFilters();
  const dealStorage: GetDeal_deal = dealStorageService.getDeal(dimensions);
  const { deal, loading, error } = useCheckoutContext();
  const dealData = loading || !deal ? dealStorage : deal;
  const redirectUnavailableDeal = useCallback(() => history.replace(Routes.DEAL_UNAVAILABLE, {}), []);

  useEffect(() => {
    if ((deal || token) && error) {
      redirectUnavailableDeal();
    }
  }, [loading, token, deal, error]);

  return { dealData, error, loading };
};

export default useDealData;
